var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalExplorer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "personalExplorer",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "folder",
    d: "M19,3H12.472a1.019,1.019,0,0,1-.447-.1L8.869,1.316A3.014,3.014,0,0,0,7.528,1H5A5.006,5.006,0,0,0,0,6V18a5.006,5.006,0,0,0,5,5H19a5.006,5.006,0,0,0,5-5V8a5.006,5.006,0,0,0-5-5ZM5,3H7.528a1.019,1.019,0,0,1,.447.1l3.156,1.579A3.014,3.014,0,0,0,12.472,5H19a3,3,0,0,1,2.779,1.882L2,6.994V6A3,3,0,0,1,5,3ZM19,21H5a3,3,0,0,1-3-3V8.994l20-.113V18A3,3,0,0,1,19,21Z",
    transform: "translate(0 -1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_01_align_center",
    "data-name": "01 align center",
    transform: "translate(5.625 10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M9.75,17.75H9V15.859A1.11,1.11,0,0,0,7.891,14.75H4.859A1.11,1.11,0,0,0,3.75,15.859V17.75H3V15.859A1.861,1.861,0,0,1,4.859,14H7.891A1.861,1.861,0,0,1,9.75,15.859Z",
    transform: "translate(0 -8.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M8.25,4.5A2.25,2.25,0,1,1,10.5,2.25,2.25,2.25,0,0,1,8.25,4.5Zm0-3.75a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,8.25.75Z",
    transform: "translate(-1.875 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalExplorer);
export default __webpack_public_path__ + "static/media/personalExplorer.592f2a803cf7913531a1af98e20d4300.svg";
export { ForwardRef as ReactComponent };